<template>
	<div>
		<button type="button" 
			:class="`btn btn-purple ${tamanhoBotao}`" 
			:disabled="enderecoStore.loading"
			@click="handleLocationClick"
			:style="paddindBotao"
		>
			{{ enderecoStore.loading ? 'Aguarde...' : textoBotao }}
			<i class="fas fa-map-marker-alt"></i>
		</button>
	</div>
</template>

<script setup>
import { useEnderecoStore } from '@/stores/localizacao';
import { computed, defineProps } from 'vue';

const enderecoStore = useEnderecoStore();

const props = defineProps({
	corrigir: {
		type: Boolean,
		default: false
	},
	tipoEndereco: String,
	endereco: {
		type: Object,
		default: () => ({})
	},
	segundaSaida: {
		type: Boolean,
		default: false
	}
});

const textoBotao = computed(() => props.corrigir ? 'Corrigir' : 'Usar minha localização');
const tamanhoBotao = computed(() => props.corrigir ? '' : 'w-100');
const paddindBotao = computed(() => props.corrigir ? 'padding: 0.25rem 0.5rem;' : '');

function handleLocationClick() {
	enderecoStore.abrirModalLocalizacao({
		endereco: props.endereco,
		tipoEndereco: props.tipoEndereco,
		segundaSaida: props.segundaSaida,
		corrigir: props.corrigir
	});
}
</script>